<ng-container *ngIf="courses.length > 0">
  <h4 class="carousel-title">{{title}}</h4>
  <app-course-slideshow [courses]="courses"></app-course-slideshow>
</ng-container>
